module.exports = __webpack_public_path__ + "static/media/main_slider_3.e523223d.jpg";